// @generated by protoc-gen-es v2.16.0 with parameter "target=ts,json_types=true"
// @generated from file bundles/v1/events.proto (package bundles.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Asset, AssetJson, AssetType, AssetTypeJson, Bundle, BundleJson, ConversionSource, ConversionSourceJson, ConversionType, ConversionTypeJson, Destination, DestinationJson, EntryPoint, EntryPointJson, ModuleTemplate, ModuleTemplateJson, Suite, SuiteJson, User, UserJson } from "./bundle_pb";
import { file_bundles_v1_bundle } from "./bundle_pb";
import type { GeoLocation, GeoLocationJson } from "./common_pb";
import { file_bundles_v1_common } from "./common_pb";
import type { DeviceType, DeviceTypeJson } from "./rules_pb";
import { file_bundles_v1_rules } from "./rules_pb";
import { file_common_v1_events } from "../../common/v1/events_pb";
import type { StructJson, Timestamp, TimestampJson, Value, ValueJson } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_struct, file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { JsonObject, Message } from "@bufbuild/protobuf";

/**
 * Describes the file bundles/v1/events.proto.
 */
export const file_bundles_v1_events: GenFile =
	/*@__PURE__*/
	fileDesc(
		"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",
		[file_bundles_v1_bundle, file_bundles_v1_common, file_bundles_v1_rules, file_common_v1_events, file_google_protobuf_struct, file_google_protobuf_timestamp],
	);

/**
 * @generated from message bundles.v1.SessionInfo
 */
export type SessionInfo = Message<"bundles.v1.SessionInfo"> & {
	/**
	 * @generated from field: string rdservice_cookie = 1;
	 */
	rdserviceCookie: string;

	/**
	 * From Heap cookie
	 *
	 * @generated from field: string heap_session_id = 2;
	 */
	heapSessionId: string;

	/**
	 * @generated from field: string heap_user_id = 3;
	 */
	heapUserId: string;

	/**
	 * @generated from field: string heap_page_view_id = 4;
	 */
	heapPageViewId: string;
};

/**
 * @generated from message bundles.v1.SessionInfo
 */
export type SessionInfoJson = {
	/**
	 * @generated from field: string rdservice_cookie = 1;
	 */
	rdserviceCookie?: string;

	/**
	 * From Heap cookie
	 *
	 * @generated from field: string heap_session_id = 2;
	 */
	heapSessionId?: string;

	/**
	 * @generated from field: string heap_user_id = 3;
	 */
	heapUserId?: string;

	/**
	 * @generated from field: string heap_page_view_id = 4;
	 */
	heapPageViewId?: string;
};

/**
 * Describes the message bundles.v1.SessionInfo.
 * Use `create(SessionInfoSchema)` to create a new message.
 */
export const SessionInfoSchema: GenMessage<SessionInfo, { jsonType: SessionInfoJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_events, 0);

/**
 * @generated from message bundles.v1.RequestInfo
 */
export type RequestInfo = Message<"bundles.v1.RequestInfo"> & {
	/**
	 * @generated from field: string remote_ip = 1;
	 */
	remoteIp: string;

	/**
	 * @generated from field: bundles.v1.DeviceType device_type = 2;
	 */
	deviceType: DeviceType;

	/**
	 * @generated from field: map<string, string> query_params = 3;
	 */
	queryParams: { [key: string]: string };

	/**
	 * @generated from field: map<string, string> request_headers = 4;
	 */
	requestHeaders: { [key: string]: string };

	/**
	 * @generated from field: bundles.v1.GeoLocationSource geo_source = 8;
	 */
	geoSource: GeoLocationSource;

	/**
	 * @generated from field: bundles.v1.GeoLocation geo_location = 9;
	 */
	geoLocation?: GeoLocation | undefined;
};

/**
 * @generated from message bundles.v1.RequestInfo
 */
export type RequestInfoJson = {
	/**
	 * @generated from field: string remote_ip = 1;
	 */
	remoteIp?: string;

	/**
	 * @generated from field: bundles.v1.DeviceType device_type = 2;
	 */
	deviceType?: DeviceTypeJson;

	/**
	 * @generated from field: map<string, string> query_params = 3;
	 */
	queryParams?: { [key: string]: string };

	/**
	 * @generated from field: map<string, string> request_headers = 4;
	 */
	requestHeaders?: { [key: string]: string };

	/**
	 * @generated from field: bundles.v1.GeoLocationSource geo_source = 8;
	 */
	geoSource?: GeoLocationSourceJson;

	/**
	 * @generated from field: bundles.v1.GeoLocation geo_location = 9;
	 */
	geoLocation?: GeoLocationJson;
};

/**
 * Describes the message bundles.v1.RequestInfo.
 * Use `create(RequestInfoSchema)` to create a new message.
 */
export const RequestInfoSchema: GenMessage<RequestInfo, { jsonType: RequestInfoJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_events, 1);

/**
 * PageView is emitted event data from a page view
 *
 * @generated from message bundles.v1.PageView
 */
export type PageView = Message<"bundles.v1.PageView"> & {
	/**
	 * The asset a user interacted with to enter this suite
	 *
	 * @generated from field: bundles.v1.EntryPoint entry_point = 7;
	 */
	entryPoint?: EntryPoint | undefined;

	/**
	 * The name of the entry point
	 *
	 * @generated from field: string entry_point_name = 12;
	 */
	entryPointName: string;

	/**
	 * The asset type of the entry point
	 *
	 * @generated from field: bundles.v1.AssetType entry_point_asset_type = 13;
	 */
	entryPointAssetType: AssetType;

	/**
	 * The suite a user interacted with
	 *
	 * @generated from field: bundles.v1.Suite suite = 1;
	 */
	suite?: Suite | undefined;

	/**
	 * The asset a user interacted with that triggered this event
	 *
	 * @generated from field: bundles.v1.Asset asset = 2;
	 */
	asset?: Asset | undefined;

	/**
	 * The conversion type set in suite.assets.key for this asset.
	 *
	 * @generated from field: bundles.v1.ConversionType conversion_type = 9 [deprecated = true];
	 * @deprecated
	 */
	conversionType: ConversionType;

	/**
	 * The conversion component set in suite.assets.key for this asset.
	 *
	 * @generated from field: string conversion_component = 10 [deprecated = true];
	 * @deprecated
	 */
	conversionComponent: string;

	/**
	 * if a flowid cookie is detected, this is their user information
	 *
	 * @generated from field: bundles.v1.User user = 3;
	 */
	user?: User | undefined;

	/**
	 * request headers, ip address, location, etc...
	 *
	 * @generated from field: bundles.v1.RequestInfo request_info = 4;
	 */
	requestInfo?: RequestInfo | undefined;

	/**
	 * rds and heap cookies
	 *
	 * @generated from field: bundles.v1.SessionInfo session_info = 5;
	 */
	sessionInfo?: SessionInfo | undefined;

	/**
	 * metadata passed from entrypoint
	 *
	 * @generated from field: google.protobuf.Struct request_metadata = 8;
	 */
	requestMetadata?: JsonObject | undefined;

	/**
	 * @generated from field: google.protobuf.Timestamp timestamp = 6;
	 */
	timestamp?: Timestamp | undefined;

	/**
	 * ML session information
	 *
	 * @generated from field: bundles.v1.ConversionMetaData ml_metadata = 11;
	 */
	mlMetadata?: ConversionMetaData | undefined;

	/**
	 * The asset key of the corresponding experiment node
	 *
	 * @generated from field: string experiment_key = 14;
	 */
	experimentKey: string;

	/**
	 * Determined using request headers and user-agent parsing
	 *
	 * @generated from field: bool is_bot = 15;
	 */
	isBot: boolean;

	/**
	 * Whether or not the bot status has been verified
	 *
	 * @generated from field: bool is_verified = 17;
	 */
	isVerified: boolean;

	/**
	 * @generated from field: map<string, google.protobuf.Value> contact_properties = 16;
	 */
	contactProperties: { [key: string]: Value };
};

/**
 * PageView is emitted event data from a page view
 *
 * @generated from message bundles.v1.PageView
 */
export type PageViewJson = {
	/**
	 * The asset a user interacted with to enter this suite
	 *
	 * @generated from field: bundles.v1.EntryPoint entry_point = 7;
	 */
	entryPoint?: EntryPointJson;

	/**
	 * The name of the entry point
	 *
	 * @generated from field: string entry_point_name = 12;
	 */
	entryPointName?: string;

	/**
	 * The asset type of the entry point
	 *
	 * @generated from field: bundles.v1.AssetType entry_point_asset_type = 13;
	 */
	entryPointAssetType?: AssetTypeJson;

	/**
	 * The suite a user interacted with
	 *
	 * @generated from field: bundles.v1.Suite suite = 1;
	 */
	suite?: SuiteJson;

	/**
	 * The asset a user interacted with that triggered this event
	 *
	 * @generated from field: bundles.v1.Asset asset = 2;
	 */
	asset?: AssetJson;

	/**
	 * The conversion type set in suite.assets.key for this asset.
	 *
	 * @generated from field: bundles.v1.ConversionType conversion_type = 9 [deprecated = true];
	 * @deprecated
	 */
	conversionType?: ConversionTypeJson;

	/**
	 * The conversion component set in suite.assets.key for this asset.
	 *
	 * @generated from field: string conversion_component = 10 [deprecated = true];
	 * @deprecated
	 */
	conversionComponent?: string;

	/**
	 * if a flowid cookie is detected, this is their user information
	 *
	 * @generated from field: bundles.v1.User user = 3;
	 */
	user?: UserJson;

	/**
	 * request headers, ip address, location, etc...
	 *
	 * @generated from field: bundles.v1.RequestInfo request_info = 4;
	 */
	requestInfo?: RequestInfoJson;

	/**
	 * rds and heap cookies
	 *
	 * @generated from field: bundles.v1.SessionInfo session_info = 5;
	 */
	sessionInfo?: SessionInfoJson;

	/**
	 * metadata passed from entrypoint
	 *
	 * @generated from field: google.protobuf.Struct request_metadata = 8;
	 */
	requestMetadata?: StructJson;

	/**
	 * @generated from field: google.protobuf.Timestamp timestamp = 6;
	 */
	timestamp?: TimestampJson;

	/**
	 * ML session information
	 *
	 * @generated from field: bundles.v1.ConversionMetaData ml_metadata = 11;
	 */
	mlMetadata?: ConversionMetaDataJson;

	/**
	 * The asset key of the corresponding experiment node
	 *
	 * @generated from field: string experiment_key = 14;
	 */
	experimentKey?: string;

	/**
	 * Determined using request headers and user-agent parsing
	 *
	 * @generated from field: bool is_bot = 15;
	 */
	isBot?: boolean;

	/**
	 * Whether or not the bot status has been verified
	 *
	 * @generated from field: bool is_verified = 17;
	 */
	isVerified?: boolean;

	/**
	 * @generated from field: map<string, google.protobuf.Value> contact_properties = 16;
	 */
	contactProperties?: { [key: string]: ValueJson };
};

/**
 * Describes the message bundles.v1.PageView.
 * Use `create(PageViewSchema)` to create a new message.
 */
export const PageViewSchema: GenMessage<PageView, { jsonType: PageViewJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_events, 2);

/**
 * Emitted on code scan
 *
 * @generated from message bundles.v1.Scan
 */
export type Scan = Message<"bundles.v1.Scan"> & {
	/**
	 * The asset a user interacted with to enter this suite
	 *
	 * @generated from field: bundles.v1.EntryPoint entry_point = 7;
	 */
	entryPoint?: EntryPoint | undefined;

	/**
	 * The name of the entry point
	 *
	 * @generated from field: string entry_point_name = 10;
	 */
	entryPointName: string;

	/**
	 * The asset type of the entry point
	 *
	 * @generated from field: bundles.v1.AssetType entry_point_asset_type = 11;
	 */
	entryPointAssetType: AssetType;

	/**
	 * The suite a user interacted with
	 *
	 * @generated from field: bundles.v1.Suite suite = 1;
	 */
	suite?: Suite | undefined;

	/**
	 * The key in suite.assets corresponding to the asset a user interacted with that triggered this event
	 *
	 * @generated from field: string asset_key = 2;
	 */
	assetKey: string;

	/**
	 * The conversion type set in suite.assets.key for this asset. this is currently unset for scan events
	 *
	 * @generated from field: bundles.v1.ConversionType conversion_type = 9 [deprecated = true];
	 * @deprecated
	 */
	conversionType: ConversionType;

	/**
	 * if a flowid cookie is detected, this is their user information
	 *
	 * @generated from field: bundles.v1.User user = 3;
	 */
	user?: User | undefined;

	/**
	 * request headers, ip address, location, etc...
	 *
	 * @generated from field: bundles.v1.RequestInfo request_info = 4;
	 */
	requestInfo?: RequestInfo | undefined;

	/**
	 * rds and heap cookies
	 *
	 * @generated from field: bundles.v1.SessionInfo session_info = 5;
	 */
	sessionInfo?: SessionInfo | undefined;

	/**
	 * metadata passed from entrypoint
	 *
	 * @generated from field: google.protobuf.Struct request_metadata = 8;
	 */
	requestMetadata?: JsonObject | undefined;

	/**
	 * @generated from field: google.protobuf.Timestamp timestamp = 6;
	 */
	timestamp?: Timestamp | undefined;

	/**
	 * The asset key of the corresponding experiment node
	 *
	 * @generated from field: string experiment_key = 12;
	 */
	experimentKey: string;

	/**
	 * Determined using request headers and user-agent parsing
	 *
	 * @generated from field: bool is_bot = 13;
	 */
	isBot: boolean;

	/**
	 * Whether or not the bot status has been verified
	 *
	 * @generated from field: bool is_verified = 14;
	 */
	isVerified: boolean;

	/**
	 * @generated from field: map<string, google.protobuf.Value> contact_properties = 15;
	 */
	contactProperties: { [key: string]: Value };
};

/**
 * Emitted on code scan
 *
 * @generated from message bundles.v1.Scan
 */
export type ScanJson = {
	/**
	 * The asset a user interacted with to enter this suite
	 *
	 * @generated from field: bundles.v1.EntryPoint entry_point = 7;
	 */
	entryPoint?: EntryPointJson;

	/**
	 * The name of the entry point
	 *
	 * @generated from field: string entry_point_name = 10;
	 */
	entryPointName?: string;

	/**
	 * The asset type of the entry point
	 *
	 * @generated from field: bundles.v1.AssetType entry_point_asset_type = 11;
	 */
	entryPointAssetType?: AssetTypeJson;

	/**
	 * The suite a user interacted with
	 *
	 * @generated from field: bundles.v1.Suite suite = 1;
	 */
	suite?: SuiteJson;

	/**
	 * The key in suite.assets corresponding to the asset a user interacted with that triggered this event
	 *
	 * @generated from field: string asset_key = 2;
	 */
	assetKey?: string;

	/**
	 * The conversion type set in suite.assets.key for this asset. this is currently unset for scan events
	 *
	 * @generated from field: bundles.v1.ConversionType conversion_type = 9 [deprecated = true];
	 * @deprecated
	 */
	conversionType?: ConversionTypeJson;

	/**
	 * if a flowid cookie is detected, this is their user information
	 *
	 * @generated from field: bundles.v1.User user = 3;
	 */
	user?: UserJson;

	/**
	 * request headers, ip address, location, etc...
	 *
	 * @generated from field: bundles.v1.RequestInfo request_info = 4;
	 */
	requestInfo?: RequestInfoJson;

	/**
	 * rds and heap cookies
	 *
	 * @generated from field: bundles.v1.SessionInfo session_info = 5;
	 */
	sessionInfo?: SessionInfoJson;

	/**
	 * metadata passed from entrypoint
	 *
	 * @generated from field: google.protobuf.Struct request_metadata = 8;
	 */
	requestMetadata?: StructJson;

	/**
	 * @generated from field: google.protobuf.Timestamp timestamp = 6;
	 */
	timestamp?: TimestampJson;

	/**
	 * The asset key of the corresponding experiment node
	 *
	 * @generated from field: string experiment_key = 12;
	 */
	experimentKey?: string;

	/**
	 * Determined using request headers and user-agent parsing
	 *
	 * @generated from field: bool is_bot = 13;
	 */
	isBot?: boolean;

	/**
	 * Whether or not the bot status has been verified
	 *
	 * @generated from field: bool is_verified = 14;
	 */
	isVerified?: boolean;

	/**
	 * @generated from field: map<string, google.protobuf.Value> contact_properties = 15;
	 */
	contactProperties?: { [key: string]: ValueJson };
};

/**
 * Describes the message bundles.v1.Scan.
 * Use `create(ScanSchema)` to create a new message.
 */
export const ScanSchema: GenMessage<Scan, { jsonType: ScanJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_events, 3);

/**
 * Emitted on click
 *
 * @generated from message bundles.v1.Click
 */
export type Click = Message<"bundles.v1.Click"> & {
	/**
	 * The asset a user interacted with to enter this suite
	 *
	 * @generated from field: bundles.v1.EntryPoint entry_point = 7;
	 */
	entryPoint?: EntryPoint | undefined;

	/**
	 * The name of the entry point
	 *
	 * @generated from field: string entry_point_name = 10;
	 */
	entryPointName: string;

	/**
	 * The asset type of the entry point
	 *
	 * @generated from field: bundles.v1.AssetType entry_point_asset_type = 11;
	 */
	entryPointAssetType: AssetType;

	/**
	 * The suite a user interacted with
	 *
	 * @generated from field: bundles.v1.Suite suite = 1;
	 */
	suite?: Suite | undefined;

	/**
	 * The key in suite.assets corresponding to the asset a user interacted with that triggered this event
	 *
	 * @generated from field: string asset_key = 2;
	 */
	assetKey: string;

	/**
	 * The conversion type set in suite.assets.key for this asset. this is currently unset for scan events
	 *
	 * @generated from field: bundles.v1.ConversionType conversion_type = 9 [deprecated = true];
	 * @deprecated
	 */
	conversionType: ConversionType;

	/**
	 * if a flowid cookie is detected, this is their user information
	 *
	 * @generated from field: bundles.v1.User user = 3;
	 */
	user?: User | undefined;

	/**
	 * request headers, ip address, location, etc...
	 *
	 * @generated from field: bundles.v1.RequestInfo request_info = 4;
	 */
	requestInfo?: RequestInfo | undefined;

	/**
	 * rds and heap cookies
	 *
	 * @generated from field: bundles.v1.SessionInfo session_info = 5;
	 */
	sessionInfo?: SessionInfo | undefined;

	/**
	 * metadata passed from entrypoint
	 *
	 * @generated from field: google.protobuf.Struct request_metadata = 8;
	 */
	requestMetadata?: JsonObject | undefined;

	/**
	 * @generated from field: google.protobuf.Timestamp timestamp = 6;
	 */
	timestamp?: Timestamp | undefined;

	/**
	 * The asset key of the corresponding experiment node
	 *
	 * @generated from field: string experiment_key = 12;
	 */
	experimentKey: string;

	/**
	 * Determined using request headers and user-agent parsing
	 *
	 * @generated from field: bool is_bot = 13;
	 */
	isBot: boolean;

	/**
	 * Whether or not the bot status has been verified
	 *
	 * @generated from field: bool is_verified = 14;
	 */
	isVerified: boolean;

	/**
	 * @generated from field: map<string, google.protobuf.Value> contact_properties = 15;
	 */
	contactProperties: { [key: string]: Value };
};

/**
 * Emitted on click
 *
 * @generated from message bundles.v1.Click
 */
export type ClickJson = {
	/**
	 * The asset a user interacted with to enter this suite
	 *
	 * @generated from field: bundles.v1.EntryPoint entry_point = 7;
	 */
	entryPoint?: EntryPointJson;

	/**
	 * The name of the entry point
	 *
	 * @generated from field: string entry_point_name = 10;
	 */
	entryPointName?: string;

	/**
	 * The asset type of the entry point
	 *
	 * @generated from field: bundles.v1.AssetType entry_point_asset_type = 11;
	 */
	entryPointAssetType?: AssetTypeJson;

	/**
	 * The suite a user interacted with
	 *
	 * @generated from field: bundles.v1.Suite suite = 1;
	 */
	suite?: SuiteJson;

	/**
	 * The key in suite.assets corresponding to the asset a user interacted with that triggered this event
	 *
	 * @generated from field: string asset_key = 2;
	 */
	assetKey?: string;

	/**
	 * The conversion type set in suite.assets.key for this asset. this is currently unset for scan events
	 *
	 * @generated from field: bundles.v1.ConversionType conversion_type = 9 [deprecated = true];
	 * @deprecated
	 */
	conversionType?: ConversionTypeJson;

	/**
	 * if a flowid cookie is detected, this is their user information
	 *
	 * @generated from field: bundles.v1.User user = 3;
	 */
	user?: UserJson;

	/**
	 * request headers, ip address, location, etc...
	 *
	 * @generated from field: bundles.v1.RequestInfo request_info = 4;
	 */
	requestInfo?: RequestInfoJson;

	/**
	 * rds and heap cookies
	 *
	 * @generated from field: bundles.v1.SessionInfo session_info = 5;
	 */
	sessionInfo?: SessionInfoJson;

	/**
	 * metadata passed from entrypoint
	 *
	 * @generated from field: google.protobuf.Struct request_metadata = 8;
	 */
	requestMetadata?: StructJson;

	/**
	 * @generated from field: google.protobuf.Timestamp timestamp = 6;
	 */
	timestamp?: TimestampJson;

	/**
	 * The asset key of the corresponding experiment node
	 *
	 * @generated from field: string experiment_key = 12;
	 */
	experimentKey?: string;

	/**
	 * Determined using request headers and user-agent parsing
	 *
	 * @generated from field: bool is_bot = 13;
	 */
	isBot?: boolean;

	/**
	 * Whether or not the bot status has been verified
	 *
	 * @generated from field: bool is_verified = 14;
	 */
	isVerified?: boolean;

	/**
	 * @generated from field: map<string, google.protobuf.Value> contact_properties = 15;
	 */
	contactProperties?: { [key: string]: ValueJson };
};

/**
 * Describes the message bundles.v1.Click.
 * Use `create(ClickSchema)` to create a new message.
 */
export const ClickSchema: GenMessage<Click, { jsonType: ClickJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_events, 4);

/**
 * @generated from message bundles.v1.Interaction
 */
export type Interaction = Message<"bundles.v1.Interaction"> & {
	/**
	 * @generated from field: bundles.v1.InteractionType interaction_type = 1;
	 */
	interactionType: InteractionType;

	/**
	 * @generated from field: google.protobuf.Timestamp timestamp = 2;
	 */
	timestamp?: Timestamp | undefined;
};

/**
 * @generated from message bundles.v1.Interaction
 */
export type InteractionJson = {
	/**
	 * @generated from field: bundles.v1.InteractionType interaction_type = 1;
	 */
	interactionType?: InteractionTypeJson;

	/**
	 * @generated from field: google.protobuf.Timestamp timestamp = 2;
	 */
	timestamp?: TimestampJson;
};

/**
 * Describes the message bundles.v1.Interaction.
 * Use `create(InteractionSchema)` to create a new message.
 */
export const InteractionSchema: GenMessage<Interaction, { jsonType: InteractionJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_events, 5);

/**
 * @generated from message bundles.v1.ConversionMetaData
 */
export type ConversionMetaData = Message<"bundles.v1.ConversionMetaData"> & {
	/**
	 * @generated from field: string parent_ml_request_id = 5;
	 */
	parentMlRequestId: string;

	/**
	 * @generated from field: string ml_request_id = 1;
	 */
	mlRequestId: string;

	/**
	 * @generated from field: google.protobuf.Timestamp pageload_timestamp = 2;
	 */
	pageloadTimestamp?: Timestamp | undefined;

	/**
	 * @generated from field: google.protobuf.Timestamp first_interaction_timestamp = 3 [deprecated = true];
	 * @deprecated
	 */
	firstInteractionTimestamp?: Timestamp | undefined;

	/**
	 * @generated from field: repeated bundles.v1.Interaction interactions = 4;
	 */
	interactions: Interaction[];
};

/**
 * @generated from message bundles.v1.ConversionMetaData
 */
export type ConversionMetaDataJson = {
	/**
	 * @generated from field: string parent_ml_request_id = 5;
	 */
	parentMlRequestId?: string;

	/**
	 * @generated from field: string ml_request_id = 1;
	 */
	mlRequestId?: string;

	/**
	 * @generated from field: google.protobuf.Timestamp pageload_timestamp = 2;
	 */
	pageloadTimestamp?: TimestampJson;

	/**
	 * @generated from field: google.protobuf.Timestamp first_interaction_timestamp = 3 [deprecated = true];
	 * @deprecated
	 */
	firstInteractionTimestamp?: TimestampJson;

	/**
	 * @generated from field: repeated bundles.v1.Interaction interactions = 4;
	 */
	interactions?: InteractionJson[];
};

/**
 * Describes the message bundles.v1.ConversionMetaData.
 * Use `create(ConversionMetaDataSchema)` to create a new message.
 */
export const ConversionMetaDataSchema: GenMessage<ConversionMetaData, { jsonType: ConversionMetaDataJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_events, 6);

/**
 * Conversion is emitted event data on a conversion (when the user submits data)
 *
 * @generated from message bundles.v1.Conversion
 */
export type Conversion = Message<"bundles.v1.Conversion"> & {
	/**
	 * The asset a user interacted with to enter this suite
	 *
	 * @generated from field: bundles.v1.EntryPoint entry_point = 13;
	 */
	entryPoint?: EntryPoint | undefined;

	/**
	 * The name of the entry point
	 *
	 * @generated from field: string entry_point_name = 15;
	 */
	entryPointName: string;

	/**
	 * The asset type of the entry point
	 *
	 * @generated from field: bundles.v1.AssetType entry_point_asset_type = 17;
	 */
	entryPointAssetType: AssetType;

	/**
	 * The suite a user interacted with
	 *
	 * @generated from field: bundles.v1.Suite suite = 1;
	 */
	suite?: Suite | undefined;

	/**
	 * The key in suite.assets corresponding to the asset a user interacted with that triggered this event
	 *
	 * @generated from field: string key = 2;
	 */
	key: string;

	/**
	 * The conversion type set in suite.assets.key for this asset. this is currently unset for scan events
	 *
	 * @generated from field: bundles.v1.ConversionType conversion_type = 3;
	 */
	conversionType: ConversionType;

	/**
	 * Maps conversion to conversion source
	 *
	 * @generated from field: bundles.v1.ConversionSource conversion_source = 20;
	 */
	conversionSource: ConversionSource;

	/**
	 * The component on a page that triggered this event. corresponds to a component.id on a PAGE_V2
	 *
	 * @generated from field: string conversion_component = 4;
	 */
	conversionComponent: string;

	/**
	 * The conversion subtype is an optional value used for externally generated conversions.  This is currently used for the pixel integration
	 *
	 * @generated from field: string conversion_subtype = 16;
	 */
	conversionSubtype: string;

	/**
	 * where the user got pushed after converting
	 *
	 * @generated from field: bundles.v1.Destination destination = 5;
	 */
	destination?: Destination | undefined;

	/**
	 * The data posted to Execute which triggered the conversion (ie. form data)
	 *
	 * @generated from field: google.protobuf.Struct request_data = 6;
	 */
	requestData?: JsonObject | undefined;

	/**
	 * the data returned to the client after converting (ie. the next destination to go)
	 *
	 * @generated from field: google.protobuf.Struct response_data = 7;
	 */
	responseData?: JsonObject | undefined;

	/**
	 * if a flowid cookie is detected, this is their user information
	 *
	 * @generated from field: bundles.v1.User user = 8;
	 */
	user?: User | undefined;

	/**
	 * request headers, ip address, location, etc...
	 *
	 * @generated from field: bundles.v1.RequestInfo request_info = 9;
	 */
	requestInfo?: RequestInfo | undefined;

	/**
	 * rds and heap cookies
	 *
	 * @generated from field: bundles.v1.SessionInfo session_info = 10;
	 */
	sessionInfo?: SessionInfo | undefined;

	/**
	 * metadata passed from entrypoint
	 *
	 * @generated from field: google.protobuf.Struct request_metadata = 14;
	 */
	requestMetadata?: JsonObject | undefined;

	/**
	 * metadata passed from pixel service
	 *
	 * @generated from field: google.protobuf.Struct pixel_metadata = 19;
	 */
	pixelMetadata?: JsonObject | undefined;

	/**
	 * @generated from field: google.protobuf.Timestamp timestamp = 11;
	 */
	timestamp?: Timestamp | undefined;

	/**
	 * ML session information
	 *
	 * @generated from field: bundles.v1.ConversionMetaData ml_metadata = 12;
	 */
	mlMetadata?: ConversionMetaData | undefined;

	/**
	 * The asset key of the corresponding experiment node
	 *
	 * @generated from field: string experiment_key = 18;
	 */
	experimentKey: string;

	/**
	 * Determined using request headers and user-agent parsing
	 *
	 * @generated from field: bool is_bot = 21;
	 */
	isBot: boolean;

	/**
	 * Whether or not the bot status has been verified
	 *
	 * @generated from field: bool is_verified = 25;
	 */
	isVerified: boolean;

	/**
	 * contact properties loaded during the conversion
	 *
	 * @generated from field: map<string, google.protobuf.Value> contact_properties = 24;
	 */
	contactProperties: { [key: string]: Value };
};

/**
 * Conversion is emitted event data on a conversion (when the user submits data)
 *
 * @generated from message bundles.v1.Conversion
 */
export type ConversionJson = {
	/**
	 * The asset a user interacted with to enter this suite
	 *
	 * @generated from field: bundles.v1.EntryPoint entry_point = 13;
	 */
	entryPoint?: EntryPointJson;

	/**
	 * The name of the entry point
	 *
	 * @generated from field: string entry_point_name = 15;
	 */
	entryPointName?: string;

	/**
	 * The asset type of the entry point
	 *
	 * @generated from field: bundles.v1.AssetType entry_point_asset_type = 17;
	 */
	entryPointAssetType?: AssetTypeJson;

	/**
	 * The suite a user interacted with
	 *
	 * @generated from field: bundles.v1.Suite suite = 1;
	 */
	suite?: SuiteJson;

	/**
	 * The key in suite.assets corresponding to the asset a user interacted with that triggered this event
	 *
	 * @generated from field: string key = 2;
	 */
	key?: string;

	/**
	 * The conversion type set in suite.assets.key for this asset. this is currently unset for scan events
	 *
	 * @generated from field: bundles.v1.ConversionType conversion_type = 3;
	 */
	conversionType?: ConversionTypeJson;

	/**
	 * Maps conversion to conversion source
	 *
	 * @generated from field: bundles.v1.ConversionSource conversion_source = 20;
	 */
	conversionSource?: ConversionSourceJson;

	/**
	 * The component on a page that triggered this event. corresponds to a component.id on a PAGE_V2
	 *
	 * @generated from field: string conversion_component = 4;
	 */
	conversionComponent?: string;

	/**
	 * The conversion subtype is an optional value used for externally generated conversions.  This is currently used for the pixel integration
	 *
	 * @generated from field: string conversion_subtype = 16;
	 */
	conversionSubtype?: string;

	/**
	 * where the user got pushed after converting
	 *
	 * @generated from field: bundles.v1.Destination destination = 5;
	 */
	destination?: DestinationJson;

	/**
	 * The data posted to Execute which triggered the conversion (ie. form data)
	 *
	 * @generated from field: google.protobuf.Struct request_data = 6;
	 */
	requestData?: StructJson;

	/**
	 * the data returned to the client after converting (ie. the next destination to go)
	 *
	 * @generated from field: google.protobuf.Struct response_data = 7;
	 */
	responseData?: StructJson;

	/**
	 * if a flowid cookie is detected, this is their user information
	 *
	 * @generated from field: bundles.v1.User user = 8;
	 */
	user?: UserJson;

	/**
	 * request headers, ip address, location, etc...
	 *
	 * @generated from field: bundles.v1.RequestInfo request_info = 9;
	 */
	requestInfo?: RequestInfoJson;

	/**
	 * rds and heap cookies
	 *
	 * @generated from field: bundles.v1.SessionInfo session_info = 10;
	 */
	sessionInfo?: SessionInfoJson;

	/**
	 * metadata passed from entrypoint
	 *
	 * @generated from field: google.protobuf.Struct request_metadata = 14;
	 */
	requestMetadata?: StructJson;

	/**
	 * metadata passed from pixel service
	 *
	 * @generated from field: google.protobuf.Struct pixel_metadata = 19;
	 */
	pixelMetadata?: StructJson;

	/**
	 * @generated from field: google.protobuf.Timestamp timestamp = 11;
	 */
	timestamp?: TimestampJson;

	/**
	 * ML session information
	 *
	 * @generated from field: bundles.v1.ConversionMetaData ml_metadata = 12;
	 */
	mlMetadata?: ConversionMetaDataJson;

	/**
	 * The asset key of the corresponding experiment node
	 *
	 * @generated from field: string experiment_key = 18;
	 */
	experimentKey?: string;

	/**
	 * Determined using request headers and user-agent parsing
	 *
	 * @generated from field: bool is_bot = 21;
	 */
	isBot?: boolean;

	/**
	 * Whether or not the bot status has been verified
	 *
	 * @generated from field: bool is_verified = 25;
	 */
	isVerified?: boolean;

	/**
	 * contact properties loaded during the conversion
	 *
	 * @generated from field: map<string, google.protobuf.Value> contact_properties = 24;
	 */
	contactProperties?: { [key: string]: ValueJson };
};

/**
 * Describes the message bundles.v1.Conversion.
 * Use `create(ConversionSchema)` to create a new message.
 */
export const ConversionSchema: GenMessage<Conversion, { jsonType: ConversionJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_events, 7);

/**
 * Emitted on event attendance
 *
 * @generated from message bundles.v1.Attendance
 */
export type Attendance = Message<"bundles.v1.Attendance"> & {
	/**
	 * @generated from field: bundles.v1.EntryPoint entry_point = 7;
	 */
	entryPoint?: EntryPoint | undefined;

	/**
	 * @generated from field: string entry_point_name = 10;
	 */
	entryPointName: string;

	/**
	 * @generated from field: bundles.v1.AssetType entry_point_asset_type = 11;
	 */
	entryPointAssetType: AssetType;

	/**
	 * @generated from field: bundles.v1.Suite suite = 1;
	 */
	suite?: Suite | undefined;

	/**
	 * @generated from field: string asset_key = 2;
	 */
	assetKey: string;

	/**
	 * @generated from field: bundles.v1.ConversionType conversion_type = 9;
	 */
	conversionType: ConversionType;

	/**
	 * @generated from field: string conversion_component = 17;
	 */
	conversionComponent: string;

	/**
	 * @generated from field: bundles.v1.User user = 3;
	 */
	user?: User | undefined;

	/**
	 * @generated from field: bundles.v1.RequestInfo request_info = 4;
	 */
	requestInfo?: RequestInfo | undefined;

	/**
	 * @generated from field: bundles.v1.SessionInfo session_info = 5;
	 */
	sessionInfo?: SessionInfo | undefined;

	/**
	 * @generated from field: google.protobuf.Struct request_metadata = 8;
	 */
	requestMetadata?: JsonObject | undefined;

	/**
	 * @generated from field: google.protobuf.Timestamp timestamp = 6;
	 */
	timestamp?: Timestamp | undefined;

	/**
	 * @generated from field: string experiment_key = 12;
	 */
	experimentKey: string;

	/**
	 * @generated from field: bool is_bot = 13;
	 */
	isBot: boolean;

	/**
	 * @generated from field: bool is_verified = 14;
	 */
	isVerified: boolean;

	/**
	 * @generated from field: google.protobuf.Struct event_properties = 15;
	 */
	eventProperties?: JsonObject | undefined;

	/**
	 * @generated from field: map<string, google.protobuf.Value> contact_properties = 16;
	 */
	contactProperties: { [key: string]: Value };
};

/**
 * Emitted on event attendance
 *
 * @generated from message bundles.v1.Attendance
 */
export type AttendanceJson = {
	/**
	 * @generated from field: bundles.v1.EntryPoint entry_point = 7;
	 */
	entryPoint?: EntryPointJson;

	/**
	 * @generated from field: string entry_point_name = 10;
	 */
	entryPointName?: string;

	/**
	 * @generated from field: bundles.v1.AssetType entry_point_asset_type = 11;
	 */
	entryPointAssetType?: AssetTypeJson;

	/**
	 * @generated from field: bundles.v1.Suite suite = 1;
	 */
	suite?: SuiteJson;

	/**
	 * @generated from field: string asset_key = 2;
	 */
	assetKey?: string;

	/**
	 * @generated from field: bundles.v1.ConversionType conversion_type = 9;
	 */
	conversionType?: ConversionTypeJson;

	/**
	 * @generated from field: string conversion_component = 17;
	 */
	conversionComponent?: string;

	/**
	 * @generated from field: bundles.v1.User user = 3;
	 */
	user?: UserJson;

	/**
	 * @generated from field: bundles.v1.RequestInfo request_info = 4;
	 */
	requestInfo?: RequestInfoJson;

	/**
	 * @generated from field: bundles.v1.SessionInfo session_info = 5;
	 */
	sessionInfo?: SessionInfoJson;

	/**
	 * @generated from field: google.protobuf.Struct request_metadata = 8;
	 */
	requestMetadata?: StructJson;

	/**
	 * @generated from field: google.protobuf.Timestamp timestamp = 6;
	 */
	timestamp?: TimestampJson;

	/**
	 * @generated from field: string experiment_key = 12;
	 */
	experimentKey?: string;

	/**
	 * @generated from field: bool is_bot = 13;
	 */
	isBot?: boolean;

	/**
	 * @generated from field: bool is_verified = 14;
	 */
	isVerified?: boolean;

	/**
	 * @generated from field: google.protobuf.Struct event_properties = 15;
	 */
	eventProperties?: StructJson;

	/**
	 * @generated from field: map<string, google.protobuf.Value> contact_properties = 16;
	 */
	contactProperties?: { [key: string]: ValueJson };
};

/**
 * Describes the message bundles.v1.Attendance.
 * Use `create(AttendanceSchema)` to create a new message.
 */
export const AttendanceSchema: GenMessage<Attendance, { jsonType: AttendanceJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_events, 8);

/**
 * AbandonConversion occurs when a conversion flow that was started was cancelled/abandoned, i.e. closing the page drawer on a suite.
 *
 * @generated from message bundles.v1.AbandonConversion
 */
export type AbandonConversion = Message<"bundles.v1.AbandonConversion"> & {
	/**
	 * @generated from field: bundles.v1.EntryPoint entry_point = 10;
	 */
	entryPoint?: EntryPoint | undefined;

	/**
	 * @generated from field: string entry_point_name = 12;
	 */
	entryPointName: string;

	/**
	 * @generated from field: bundles.v1.AssetType entry_point_asset_type = 13;
	 */
	entryPointAssetType: AssetType;

	/**
	 * @generated from field: bundles.v1.Suite suite = 1;
	 */
	suite?: Suite | undefined;

	/**
	 * @generated from field: string key = 2;
	 */
	key: string;

	/**
	 * @generated from field: bundles.v1.ConversionType conversion_type = 3 [deprecated = true];
	 * @deprecated
	 */
	conversionType: ConversionType;

	/**
	 * @generated from field: bundles.v1.ConversionSource conversion_source = 15;
	 */
	conversionSource: ConversionSource;

	/**
	 * @generated from field: string conversion_component = 4 [deprecated = true];
	 * @deprecated
	 */
	conversionComponent: string;

	/**
	 * @generated from field: bundles.v1.User user = 5;
	 */
	user?: User | undefined;

	/**
	 * @generated from field: bundles.v1.RequestInfo request_info = 6;
	 */
	requestInfo?: RequestInfo | undefined;

	/**
	 * @generated from field: bundles.v1.SessionInfo session_info = 7;
	 */
	sessionInfo?: SessionInfo | undefined;

	/**
	 * @generated from field: bundles.v1.ConversionMetaData ml_metadata = 9;
	 */
	mlMetadata?: ConversionMetaData | undefined;

	/**
	 * @generated from field: google.protobuf.Struct request_metadata = 11;
	 */
	requestMetadata?: JsonObject | undefined;

	/**
	 * @generated from field: google.protobuf.Timestamp timestamp = 8;
	 */
	timestamp?: Timestamp | undefined;

	/**
	 * @generated from field: string experiment_key = 14;
	 */
	experimentKey: string;

	/**
	 * @generated from field: bool is_bot = 16;
	 */
	isBot: boolean;

	/**
	 * @generated from field: bool is_verified = 17;
	 */
	isVerified: boolean;
};

/**
 * AbandonConversion occurs when a conversion flow that was started was cancelled/abandoned, i.e. closing the page drawer on a suite.
 *
 * @generated from message bundles.v1.AbandonConversion
 */
export type AbandonConversionJson = {
	/**
	 * @generated from field: bundles.v1.EntryPoint entry_point = 10;
	 */
	entryPoint?: EntryPointJson;

	/**
	 * @generated from field: string entry_point_name = 12;
	 */
	entryPointName?: string;

	/**
	 * @generated from field: bundles.v1.AssetType entry_point_asset_type = 13;
	 */
	entryPointAssetType?: AssetTypeJson;

	/**
	 * @generated from field: bundles.v1.Suite suite = 1;
	 */
	suite?: SuiteJson;

	/**
	 * @generated from field: string key = 2;
	 */
	key?: string;

	/**
	 * @generated from field: bundles.v1.ConversionType conversion_type = 3 [deprecated = true];
	 * @deprecated
	 */
	conversionType?: ConversionTypeJson;

	/**
	 * @generated from field: bundles.v1.ConversionSource conversion_source = 15;
	 */
	conversionSource?: ConversionSourceJson;

	/**
	 * @generated from field: string conversion_component = 4 [deprecated = true];
	 * @deprecated
	 */
	conversionComponent?: string;

	/**
	 * @generated from field: bundles.v1.User user = 5;
	 */
	user?: UserJson;

	/**
	 * @generated from field: bundles.v1.RequestInfo request_info = 6;
	 */
	requestInfo?: RequestInfoJson;

	/**
	 * @generated from field: bundles.v1.SessionInfo session_info = 7;
	 */
	sessionInfo?: SessionInfoJson;

	/**
	 * @generated from field: bundles.v1.ConversionMetaData ml_metadata = 9;
	 */
	mlMetadata?: ConversionMetaDataJson;

	/**
	 * @generated from field: google.protobuf.Struct request_metadata = 11;
	 */
	requestMetadata?: StructJson;

	/**
	 * @generated from field: google.protobuf.Timestamp timestamp = 8;
	 */
	timestamp?: TimestampJson;

	/**
	 * @generated from field: string experiment_key = 14;
	 */
	experimentKey?: string;

	/**
	 * @generated from field: bool is_bot = 16;
	 */
	isBot?: boolean;

	/**
	 * @generated from field: bool is_verified = 17;
	 */
	isVerified?: boolean;
};

/**
 * Describes the message bundles.v1.AbandonConversion.
 * Use `create(AbandonConversionSchema)` to create a new message.
 */
export const AbandonConversionSchema: GenMessage<AbandonConversion, { jsonType: AbandonConversionJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_events, 9);

/**
 * Exit signifies a suite has been intentionally exited (ie. leaving the consumer suite page altogether)
 *
 * @generated from message bundles.v1.Exit
 */
export type Exit = Message<"bundles.v1.Exit"> & {
	/**
	 * @generated from field: bundles.v1.EntryPoint entry_point = 10;
	 */
	entryPoint?: EntryPoint | undefined;

	/**
	 * @generated from field: string entry_point_name = 12;
	 */
	entryPointName: string;

	/**
	 * @generated from field: bundles.v1.AssetType entry_point_asset_type = 13;
	 */
	entryPointAssetType: AssetType;

	/**
	 * @generated from field: bundles.v1.Suite suite = 1;
	 */
	suite?: Suite | undefined;

	/**
	 * @generated from field: string key = 2;
	 */
	key: string;

	/**
	 * @generated from field: bundles.v1.User user = 5;
	 */
	user?: User | undefined;

	/**
	 * @generated from field: bundles.v1.RequestInfo request_info = 6;
	 */
	requestInfo?: RequestInfo | undefined;

	/**
	 * @generated from field: bundles.v1.SessionInfo session_info = 7;
	 */
	sessionInfo?: SessionInfo | undefined;

	/**
	 * @generated from field: bundles.v1.ConversionMetaData ml_metadata = 9;
	 */
	mlMetadata?: ConversionMetaData | undefined;

	/**
	 * @generated from field: google.protobuf.Struct request_metadata = 11;
	 */
	requestMetadata?: JsonObject | undefined;

	/**
	 * @generated from field: google.protobuf.Timestamp timestamp = 8;
	 */
	timestamp?: Timestamp | undefined;

	/**
	 * @generated from field: string experiment_key = 14;
	 */
	experimentKey: string;

	/**
	 * @generated from field: bool is_bot = 15;
	 */
	isBot: boolean;

	/**
	 * @generated from field: bool is_verified = 17;
	 */
	isVerified: boolean;

	/**
	 * @generated from field: map<string, google.protobuf.Value> contact_properties = 16;
	 */
	contactProperties: { [key: string]: Value };
};

/**
 * Exit signifies a suite has been intentionally exited (ie. leaving the consumer suite page altogether)
 *
 * @generated from message bundles.v1.Exit
 */
export type ExitJson = {
	/**
	 * @generated from field: bundles.v1.EntryPoint entry_point = 10;
	 */
	entryPoint?: EntryPointJson;

	/**
	 * @generated from field: string entry_point_name = 12;
	 */
	entryPointName?: string;

	/**
	 * @generated from field: bundles.v1.AssetType entry_point_asset_type = 13;
	 */
	entryPointAssetType?: AssetTypeJson;

	/**
	 * @generated from field: bundles.v1.Suite suite = 1;
	 */
	suite?: SuiteJson;

	/**
	 * @generated from field: string key = 2;
	 */
	key?: string;

	/**
	 * @generated from field: bundles.v1.User user = 5;
	 */
	user?: UserJson;

	/**
	 * @generated from field: bundles.v1.RequestInfo request_info = 6;
	 */
	requestInfo?: RequestInfoJson;

	/**
	 * @generated from field: bundles.v1.SessionInfo session_info = 7;
	 */
	sessionInfo?: SessionInfoJson;

	/**
	 * @generated from field: bundles.v1.ConversionMetaData ml_metadata = 9;
	 */
	mlMetadata?: ConversionMetaDataJson;

	/**
	 * @generated from field: google.protobuf.Struct request_metadata = 11;
	 */
	requestMetadata?: StructJson;

	/**
	 * @generated from field: google.protobuf.Timestamp timestamp = 8;
	 */
	timestamp?: TimestampJson;

	/**
	 * @generated from field: string experiment_key = 14;
	 */
	experimentKey?: string;

	/**
	 * @generated from field: bool is_bot = 15;
	 */
	isBot?: boolean;

	/**
	 * @generated from field: bool is_verified = 17;
	 */
	isVerified?: boolean;

	/**
	 * @generated from field: map<string, google.protobuf.Value> contact_properties = 16;
	 */
	contactProperties?: { [key: string]: ValueJson };
};

/**
 * Describes the message bundles.v1.Exit.
 * Use `create(ExitSchema)` to create a new message.
 */
export const ExitSchema: GenMessage<Exit, { jsonType: ExitJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_events, 10);

/**
 * @generated from message bundles.v1.BundleCreated
 */
export type BundleCreated = Message<"bundles.v1.BundleCreated"> & {
	/**
	 * @generated from field: bundles.v1.Bundle bundle = 1;
	 */
	bundle?: Bundle | undefined;
};

/**
 * @generated from message bundles.v1.BundleCreated
 */
export type BundleCreatedJson = {
	/**
	 * @generated from field: bundles.v1.Bundle bundle = 1;
	 */
	bundle?: BundleJson;
};

/**
 * Describes the message bundles.v1.BundleCreated.
 * Use `create(BundleCreatedSchema)` to create a new message.
 */
export const BundleCreatedSchema: GenMessage<BundleCreated, { jsonType: BundleCreatedJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_events, 11);

/**
 * @generated from message bundles.v1.BundleUpdated
 */
export type BundleUpdated = Message<"bundles.v1.BundleUpdated"> & {
	/**
	 * @generated from field: bundles.v1.Bundle bundle = 1;
	 */
	bundle?: Bundle | undefined;
};

/**
 * @generated from message bundles.v1.BundleUpdated
 */
export type BundleUpdatedJson = {
	/**
	 * @generated from field: bundles.v1.Bundle bundle = 1;
	 */
	bundle?: BundleJson;
};

/**
 * Describes the message bundles.v1.BundleUpdated.
 * Use `create(BundleUpdatedSchema)` to create a new message.
 */
export const BundleUpdatedSchema: GenMessage<BundleUpdated, { jsonType: BundleUpdatedJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_events, 12);

/**
 * @generated from message bundles.v1.BundleDeleted
 */
export type BundleDeleted = Message<"bundles.v1.BundleDeleted"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;
};

/**
 * @generated from message bundles.v1.BundleDeleted
 */
export type BundleDeletedJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;
};

/**
 * Describes the message bundles.v1.BundleDeleted.
 * Use `create(BundleDeletedSchema)` to create a new message.
 */
export const BundleDeletedSchema: GenMessage<BundleDeleted, { jsonType: BundleDeletedJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_events, 13);

/**
 * @generated from message bundles.v1.SuiteCreated
 */
export type SuiteCreated = Message<"bundles.v1.SuiteCreated"> & {
	/**
	 * @generated from field: bundles.v1.Suite suite = 1;
	 */
	suite?: Suite | undefined;
};

/**
 * @generated from message bundles.v1.SuiteCreated
 */
export type SuiteCreatedJson = {
	/**
	 * @generated from field: bundles.v1.Suite suite = 1;
	 */
	suite?: SuiteJson;
};

/**
 * Describes the message bundles.v1.SuiteCreated.
 * Use `create(SuiteCreatedSchema)` to create a new message.
 */
export const SuiteCreatedSchema: GenMessage<SuiteCreated, { jsonType: SuiteCreatedJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_events, 14);

/**
 * @generated from message bundles.v1.SuiteUpdated
 */
export type SuiteUpdated = Message<"bundles.v1.SuiteUpdated"> & {
	/**
	 * @generated from field: bundles.v1.Suite suite = 1;
	 */
	suite?: Suite | undefined;

	/**
	 * @generated from field: optional bool ignore_analytics = 2;
	 */
	ignoreAnalytics?: boolean | undefined;
};

/**
 * @generated from message bundles.v1.SuiteUpdated
 */
export type SuiteUpdatedJson = {
	/**
	 * @generated from field: bundles.v1.Suite suite = 1;
	 */
	suite?: SuiteJson;

	/**
	 * @generated from field: optional bool ignore_analytics = 2;
	 */
	ignoreAnalytics?: boolean;
};

/**
 * Describes the message bundles.v1.SuiteUpdated.
 * Use `create(SuiteUpdatedSchema)` to create a new message.
 */
export const SuiteUpdatedSchema: GenMessage<SuiteUpdated, { jsonType: SuiteUpdatedJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_events, 15);

/**
 * @generated from message bundles.v1.SuiteDeleted
 */
export type SuiteDeleted = Message<"bundles.v1.SuiteDeleted"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;
};

/**
 * @generated from message bundles.v1.SuiteDeleted
 */
export type SuiteDeletedJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;
};

/**
 * Describes the message bundles.v1.SuiteDeleted.
 * Use `create(SuiteDeletedSchema)` to create a new message.
 */
export const SuiteDeletedSchema: GenMessage<SuiteDeleted, { jsonType: SuiteDeletedJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_events, 16);

/**
 * @generated from message bundles.v1.Contact
 */
export type Contact = Message<"bundles.v1.Contact"> & {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId: string;

	/**
	 * @generated from field: bundles.v1.User user = 3;
	 */
	user?: User | undefined;

	/**
	 * @generated from field: google.protobuf.Timestamp updated_at = 4;
	 */
	updatedAt?: Timestamp | undefined;
};

/**
 * @generated from message bundles.v1.Contact
 */
export type ContactJson = {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId?: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId?: string;

	/**
	 * @generated from field: bundles.v1.User user = 3;
	 */
	user?: UserJson;

	/**
	 * @generated from field: google.protobuf.Timestamp updated_at = 4;
	 */
	updatedAt?: TimestampJson;
};

/**
 * Describes the message bundles.v1.Contact.
 * Use `create(ContactSchema)` to create a new message.
 */
export const ContactSchema: GenMessage<Contact, { jsonType: ContactJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_events, 17);

/**
 * @generated from message bundles.v1.ContactIdentified
 */
export type ContactIdentified = Message<"bundles.v1.ContactIdentified"> & {
	/**
	 * @generated from field: bundles.v1.Contact contact = 1;
	 */
	contact?: Contact | undefined;

	/**
	 * @generated from field: string suite_id = 2;
	 */
	suiteId: string;

	/**
	 * @generated from field: bundles.v1.ContactIdentifiedChangeType change_type = 5;
	 */
	changeType: ContactIdentifiedChangeType;
};

/**
 * @generated from message bundles.v1.ContactIdentified
 */
export type ContactIdentifiedJson = {
	/**
	 * @generated from field: bundles.v1.Contact contact = 1;
	 */
	contact?: ContactJson;

	/**
	 * @generated from field: string suite_id = 2;
	 */
	suiteId?: string;

	/**
	 * @generated from field: bundles.v1.ContactIdentifiedChangeType change_type = 5;
	 */
	changeType?: ContactIdentifiedChangeTypeJson;
};

/**
 * Describes the message bundles.v1.ContactIdentified.
 * Use `create(ContactIdentifiedSchema)` to create a new message.
 */
export const ContactIdentifiedSchema: GenMessage<ContactIdentified, { jsonType: ContactIdentifiedJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_events, 18);

/**
 * @generated from message bundles.v1.ContactVerified
 */
export type ContactVerified = Message<"bundles.v1.ContactVerified"> & {
	/**
	 * @generated from field: bundles.v1.Contact contact = 1;
	 */
	contact?: Contact | undefined;
};

/**
 * @generated from message bundles.v1.ContactVerified
 */
export type ContactVerifiedJson = {
	/**
	 * @generated from field: bundles.v1.Contact contact = 1;
	 */
	contact?: ContactJson;
};

/**
 * Describes the message bundles.v1.ContactVerified.
 * Use `create(ContactVerifiedSchema)` to create a new message.
 */
export const ContactVerifiedSchema: GenMessage<ContactVerified, { jsonType: ContactVerifiedJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_events, 19);

/**
 * @generated from message bundles.v1.ModuleTemplateCreated
 */
export type ModuleTemplateCreated = Message<"bundles.v1.ModuleTemplateCreated"> & {
	/**
	 * @generated from field: bundles.v1.ModuleTemplate template = 1;
	 */
	template?: ModuleTemplate | undefined;
};

/**
 * @generated from message bundles.v1.ModuleTemplateCreated
 */
export type ModuleTemplateCreatedJson = {
	/**
	 * @generated from field: bundles.v1.ModuleTemplate template = 1;
	 */
	template?: ModuleTemplateJson;
};

/**
 * Describes the message bundles.v1.ModuleTemplateCreated.
 * Use `create(ModuleTemplateCreatedSchema)` to create a new message.
 */
export const ModuleTemplateCreatedSchema: GenMessage<ModuleTemplateCreated, { jsonType: ModuleTemplateCreatedJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_events, 20);

/**
 * @generated from message bundles.v1.ModuleTemplateUpdated
 */
export type ModuleTemplateUpdated = Message<"bundles.v1.ModuleTemplateUpdated"> & {
	/**
	 * @generated from field: bundles.v1.ModuleTemplate template = 1;
	 */
	template?: ModuleTemplate | undefined;
};

/**
 * @generated from message bundles.v1.ModuleTemplateUpdated
 */
export type ModuleTemplateUpdatedJson = {
	/**
	 * @generated from field: bundles.v1.ModuleTemplate template = 1;
	 */
	template?: ModuleTemplateJson;
};

/**
 * Describes the message bundles.v1.ModuleTemplateUpdated.
 * Use `create(ModuleTemplateUpdatedSchema)` to create a new message.
 */
export const ModuleTemplateUpdatedSchema: GenMessage<ModuleTemplateUpdated, { jsonType: ModuleTemplateUpdatedJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_events, 21);

/**
 * @generated from message bundles.v1.ModuleTemplateDeleted
 */
export type ModuleTemplateDeleted = Message<"bundles.v1.ModuleTemplateDeleted"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;
};

/**
 * @generated from message bundles.v1.ModuleTemplateDeleted
 */
export type ModuleTemplateDeletedJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;
};

/**
 * Describes the message bundles.v1.ModuleTemplateDeleted.
 * Use `create(ModuleTemplateDeletedSchema)` to create a new message.
 */
export const ModuleTemplateDeletedSchema: GenMessage<ModuleTemplateDeleted, { jsonType: ModuleTemplateDeletedJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_events, 22);

/**
 * @generated from message bundles.v1.EventVerified
 */
export type EventVerified = Message<"bundles.v1.EventVerified"> & {
	/**
	 * @generated from oneof bundles.v1.EventVerified.payload
	 */
	payload:
		| {
				/**
				 * @generated from field: bundles.v1.AbandonConversion abandon_conversion = 1;
				 */
				value: AbandonConversion;
				case: "abandonConversion";
		  }
		| {
				/**
				 * @generated from field: bundles.v1.Attendance attendance = 2;
				 */
				value: Attendance;
				case: "attendance";
		  }
		| {
				/**
				 * @generated from field: bundles.v1.Click click = 3;
				 */
				value: Click;
				case: "click";
		  }
		| {
				/**
				 * @generated from field: bundles.v1.Conversion conversion = 4;
				 */
				value: Conversion;
				case: "conversion";
		  }
		| {
				/**
				 * @generated from field: bundles.v1.Exit exit = 5;
				 */
				value: Exit;
				case: "exit";
		  }
		| {
				/**
				 * @generated from field: bundles.v1.PageView pageview = 6;
				 */
				value: PageView;
				case: "pageview";
		  }
		| {
				/**
				 * @generated from field: bundles.v1.Scan scan = 7;
				 */
				value: Scan;
				case: "scan";
		  }
		| { case: undefined; value?: undefined };
};

/**
 * @generated from message bundles.v1.EventVerified
 */
export type EventVerifiedJson = {
	/**
	 * @generated from field: bundles.v1.AbandonConversion abandon_conversion = 1;
	 */
	abandonConversion?: AbandonConversionJson;

	/**
	 * @generated from field: bundles.v1.Attendance attendance = 2;
	 */
	attendance?: AttendanceJson;

	/**
	 * @generated from field: bundles.v1.Click click = 3;
	 */
	click?: ClickJson;

	/**
	 * @generated from field: bundles.v1.Conversion conversion = 4;
	 */
	conversion?: ConversionJson;

	/**
	 * @generated from field: bundles.v1.Exit exit = 5;
	 */
	exit?: ExitJson;

	/**
	 * @generated from field: bundles.v1.PageView pageview = 6;
	 */
	pageview?: PageViewJson;

	/**
	 * @generated from field: bundles.v1.Scan scan = 7;
	 */
	scan?: ScanJson;
};

/**
 * Describes the message bundles.v1.EventVerified.
 * Use `create(EventVerifiedSchema)` to create a new message.
 */
export const EventVerifiedSchema: GenMessage<EventVerified, { jsonType: EventVerifiedJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_events, 23);

/**
 * @generated from enum bundles.v1.GeoLocationSource
 */
export enum GeoLocationSource {
	/**
	 * @generated from enum value: GEO_LOCATION_SOURCE_UNSPECIFIED = 0;
	 */
	UNSPECIFIED = 0,

	/**
	 * @generated from enum value: GEO_LOCATION_SOURCE_IP_TO_GEO = 1;
	 */
	IP_TO_GEO = 1,

	/**
	 * @generated from enum value: GEO_LOCATION_SOURCE_BROWSER_INTERSTITIAL = 2;
	 */
	BROWSER_INTERSTITIAL = 2,
}

/**
 * @generated from enum bundles.v1.GeoLocationSource
 */
export type GeoLocationSourceJson = "GEO_LOCATION_SOURCE_UNSPECIFIED" | "GEO_LOCATION_SOURCE_IP_TO_GEO" | "GEO_LOCATION_SOURCE_BROWSER_INTERSTITIAL";

/**
 * Describes the enum bundles.v1.GeoLocationSource.
 */
export const GeoLocationSourceSchema: GenEnum<GeoLocationSource, GeoLocationSourceJson> = /*@__PURE__*/ enumDesc(file_bundles_v1_events, 0);

/**
 * @generated from enum bundles.v1.InteractionType
 */
export enum InteractionType {
	/**
	 * @generated from enum value: INTERACTION_TYPE_UNSPECIFIED = 0;
	 */
	UNSPECIFIED = 0,

	/**
	 * @generated from enum value: INTERACTION_TYPE_BUTTON_CLICK = 1;
	 */
	BUTTON_CLICK = 1,

	/**
	 * @generated from enum value: INTERACTION_TYPE_SCROLL = 2;
	 */
	SCROLL = 2,

	/**
	 * @generated from enum value: INTERACTION_TYPE_CLICK = 3;
	 */
	CLICK = 3,
}

/**
 * @generated from enum bundles.v1.InteractionType
 */
export type InteractionTypeJson = "INTERACTION_TYPE_UNSPECIFIED" | "INTERACTION_TYPE_BUTTON_CLICK" | "INTERACTION_TYPE_SCROLL" | "INTERACTION_TYPE_CLICK";

/**
 * Describes the enum bundles.v1.InteractionType.
 */
export const InteractionTypeSchema: GenEnum<InteractionType, InteractionTypeJson> = /*@__PURE__*/ enumDesc(file_bundles_v1_events, 1);

/**
 * @generated from enum bundles.v1.ContactIdentifiedChangeType
 */
export enum ContactIdentifiedChangeType {
	/**
	 * @generated from enum value: CONTACT_IDENTIFIED_CHANGE_TYPE_UNSPECIFIED = 0;
	 */
	UNSPECIFIED = 0,

	/**
	 * @generated from enum value: CONTACT_IDENTIFIED_CHANGE_TYPE_NEW = 1;
	 */
	NEW = 1,

	/**
	 * @generated from enum value: CONTACT_IDENTIFIED_CHANGE_TYPE_UPDATED = 2;
	 */
	UPDATED = 2,

	/**
	 * @generated from enum value: CONTACT_IDENTIFIED_CHANGE_TYPE_EXISTING = 3;
	 */
	EXISTING = 3,
}

/**
 * @generated from enum bundles.v1.ContactIdentifiedChangeType
 */
export type ContactIdentifiedChangeTypeJson = "CONTACT_IDENTIFIED_CHANGE_TYPE_UNSPECIFIED" | "CONTACT_IDENTIFIED_CHANGE_TYPE_NEW" | "CONTACT_IDENTIFIED_CHANGE_TYPE_UPDATED" | "CONTACT_IDENTIFIED_CHANGE_TYPE_EXISTING";

/**
 * Describes the enum bundles.v1.ContactIdentifiedChangeType.
 */
export const ContactIdentifiedChangeTypeSchema: GenEnum<ContactIdentifiedChangeType, ContactIdentifiedChangeTypeJson> = /*@__PURE__*/ enumDesc(file_bundles_v1_events, 2);
